import { IRestaurant } from "../models/IRestaurant";

interface Props {
  restaurant: IRestaurant | null;
}

export default function Footer({ restaurant }: Props) {
  return (
    <footer className="rr-footer">
      &copy; {new Date().getFullYear()} {restaurant?.restourantName ?? "Restoran"}. Tüm hakları saklıdır.
    </footer>
  );
}
